import { Email } from '@fluentsms/agentnet-web-icons';
import { SvgIconProps, useTheme } from '@material-ui/core';
import React from 'react';

export const EmailDoc = (props: SvgIconProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Email
      height="auto"
      width="16"
      data-testid="document-email-icon"
      fill={theme.palette?.document?.email}
      {...props}
    />
  );
};
